import { FC, useCallback } from "react";
import { TaskStatus } from "tm-shared/types";

import { OutlineIconButton } from "@/components/OutlineIconButton";
import { useTaskStatusMeta } from "@/hooks/useTaskStatusMeta";

import { StyledBadge } from "./Styled";

type StatusCycleButtonProps = {
    value: TaskStatus;
    onChange: (next: TaskStatus) => void;
    states?: TaskStatus[];
    disabled?: boolean;
    dimension?: number;
    border?: boolean;

    photoMode?: boolean;
    photoCount?: number;
};

const DEFAULT_STATES: TaskStatus[] = [
    TaskStatus.Incomplete,
    TaskStatus.Completed,
    TaskStatus.Rejected,
];

export const StatusCycleButton: FC<StatusCycleButtonProps> = ({
    value,
    onChange,
    states = DEFAULT_STATES,
    disabled,
    border = true,
    dimension = 54,
    photoMode = false,
    photoCount = 0,
}) => {
    const handleClick = useCallback(() => {
        const idx = states.indexOf(value);
        const next = states[(idx + 1) % states.length];

        onChange(next);
    }, [value, onChange, states]);

    const { variant, icon } = useTaskStatusMeta(value, { photo: photoMode });

    return (
        <OutlineIconButton
            icon={
                <StyledBadge
                    count={photoCount}
                    showZero={false}
                    color="primary"
                >
                    {icon}
                </StyledBadge>
            }
            variant={variant}
            onClick={handleClick}
            disabled={disabled}
            border={border}
            dimension={dimension}
        />
    );
};
